<template>
  <LayoutDefault>
    <section class="financial-activities">
      <h1 class="financial-activities__title">Финансово-хозяйственная деятельность</h1>
      <table class="financial-activities__table">
        <thead>
          <tr>
            <th class="financial-activities__table-title">Категории</th>
            <th class="financial-activities__table-title">Наполнение</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in finansialCategories" :key="idx">
            <td class="financial-activities__categories">
              <p>{{ item.name }}</p>
            </td>
            <td class="financial-activities__filling">
              <Textarea
                v-if="item.link == ''"
                v-model="item.description"
                autoResize rows="4"
                cols="70"
                @change="test"
              />
              <span v-if="item.link !== ''">{{ item.link }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <BaseBtn blue text="Сохранить" />
    </section>
  </LayoutDefault>
</template>

<script>
import { ref } from 'vue'
import LayoutDefault from '@/layout/LayoutDefault'
import BaseBtn from '@/components/ui/BaseBtn.vue'

import Textarea from 'primevue/textarea'

export default {
  name: 'FInancialActivitiesView',
  components: {
    LayoutDefault,
    BaseBtn,
    Textarea
  },
  props: {
  },
  setup () {
    const finansialCategories = ref([
      {
        id: 1,
        name: 'а) информацию об объеме образовательной деятельности, финансовое обеспечение которой осуществляется:',
        description: 'за счет бюджетных ассигнований федерального бюджета 0% за счет бюджетов субъектов Российской Федерации 0% за счет местных бюджетов 0% по договорам об оказании платных образовательных услуг 100%',
        link: ''
      },
      {
        id: 2,
        name: 'б) информацию о поступлении финансовых и материальных средств по итогам финансового года',
        link: 'Otchet_finans_2020.jpg'
      },
      {
        id: 3,
        name: 'в) информацию о расходовании финансовых и материальных средств по итогам финансового года',
        link: 'Otchet_finans_2020.jpg'
      },
      {
        id: 4,
        name: 'г) копию плана финансово-хозяйственной деятельности образовательной организации, утвержденного в установленном законодательством Российской Федерации порядке, или бюджетной сметы образовательной организации',
        link: 'Finplan_2021.jpg'
      }
    ])

    return {
      finansialCategories
    }
  }
}
</script>

<style lang="scss" scoped>
.financial-activities {
  &__title {
    @include information-block-title;
    margin-bottom: 16px;
  }

  &__table {
    text-align: left;
    margin-bottom: 45px;
    border-spacing: 0 8px;

    tr {
      vertical-align: top;
      border-spacing: 0 8px
    }
  }

  &__table-title {
    font-size: 18px;
    font-weight: 500;
    padding-bottom: 8px;
  }

  &__categories {
    width: 20%;
    padding-right: 20px;

    p {
      font-size: 14px;
      line-height: 18px;
    }
  }

  &__filling {
    span {
      color: #1BA6DA;
      cursor: pointer;
    }

    :deep(.p-inputtextarea) {
      padding: 8px 12px;
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>
